import { IconButton, Snackbar } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { Alert, AlertTitle } from "@material-ui/lab";
import React, { Component, ReactNode } from "react";
import { ApiError } from "../_generated";
//import { logout } from "./Authentication";

interface Props {
  children: ReactNode;
  context?: string;
}

interface State {
  error?: Error;
  open: boolean;
}

export default class APIErrorBoundary extends Component<Props, State> {
  public state: State = {
    open: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    if (error instanceof ApiError && error.status === 403) {
      //temporary disabling logout because to not break codebuild
      //logout();
    }
    // Update state so the next render will show the fallback UI.
    return { error, open: true };
  }

  public handleClose = (
    event: React.SyntheticEvent | React.MouseEvent,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({ open: false });
  };

  public render() {
    if (this.state.error) {
      return (
        <Snackbar
          open={this.state.open}
          //   autoHideDuration={2000}
          onClose={this.handleClose}
        >
          <Alert
            severity="error"
            action={
              <IconButton
                size="small"
                color="inherit"
                onClick={this.handleClose}
              >
                <Close />
              </IconButton>
            }
          >
            {this.props.context ? (
              <AlertTitle>Error: {this.props.context}</AlertTitle>
            ) : null}
            {this.state.error.message}
          </Alert>
        </Snackbar>
      );
    }

    return this.props.children;
  }
}
